import { createFeatureSelector, createSelector } from '@ngrx/store';
import { customUserPaymentsFeatureKey, CustomUserPaymentsState, CUSTOM_USER_PAYMENTS, CUSTOM_USER_PAYMENTS_AVIS, CUSTOM_USER_PAYMENTS_DETAILS, CUSTOM_USER_PAYMENTS_FILTERS } from './custom-user-payments.reducer';



export const selectCustomUserPaymentsState = createFeatureSelector<CustomUserPaymentsState>(
    customUserPaymentsFeatureKey
  );
  
//******************************************************
  
export const selectUserPayments = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS].invoiceOverview
);

export const loadingUserPayments = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS].isLoading
);

export const errorUserPayments = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS].error
);

export const selectUserPaymentsFilters = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS_FILTERS].invoiceHistoryRequestData
);

export const selectBackToOverview = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS_FILTERS].backToOverview
);
//******************************************************

export const selectUserPaymentsDetails = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS_DETAILS].invoiceDetails
);

export const loadingUserPaymentsDetails = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS_DETAILS].isLoading
);

export const errorUserPaymentsDetails = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS_DETAILS].error
);

//******************************************************

export const selectUserPaymentsAvis = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS_AVIS].invoiceAvis
);

export const loadingUserPaymentsAvis = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS_AVIS].isLoading
);

export const errorUserPaymentsAvis = createSelector(
    selectCustomUserPaymentsState,
    (state: CustomUserPaymentsState) =>
        state[CUSTOM_USER_PAYMENTS_AVIS].error
);